import React from "react";
import businessImg from "../../Assets/img/Group (1).svg";
import { Link } from "react-router-dom";

const FindTalentSection = () => {
  return (
    <section className="bg-black ">
      <div className="container text-white  Apply-padding">
      <div className="row  align-items-center">
        {/* Image box */}
        <div className="col-md-6  mb-4 mb-md-0">
          <img
            src={businessImg}
           className="img-fluid"
            alt="Illustration of business team working with computers and digital workplace background with charts and people in professional clothing"
          />
        </div>

        {/* Content box */}
        <div className="col-md-6 d-flex justify-content-center align-items-center">
          <div className="titel-content text-center">
            <h2>Find the Right Talent or the Right Job – Fast.</h2>
            <p>
              Whether you're an employer looking to fill key roles or a professional
              ready for your next opportunity, we make the process quick, efficient,
              and tailored to your needs. Join our network and take the next step
              with confidence.
            </p>
            <Link to="./contact-us">
              <button
                type="button"
                className="btn-purple-home py-2"
                style={{ width: "40%", border: "2px solid white" }}
              >
                Share Your Requirement
              </button>
            </Link>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default FindTalentSection;
